import {JobRiskClass} from '../job-risk-class';

export const HUMANIA_EMMA_JOB_CATEGORY_ID_TO_RISK_CLASS: Record<number, JobRiskClass> = {
  1: JobRiskClass['2A'],
  2: JobRiskClass['2A'],
  3: JobRiskClass['1A'],
  4: JobRiskClass['C'],
  5: JobRiskClass['C'],
  6: JobRiskClass['2A'],
  7: JobRiskClass['3A'],
  8: JobRiskClass['C'],
  9: JobRiskClass['C'],
  10: JobRiskClass['4A'],
  11: JobRiskClass['3A'],
  12: JobRiskClass['3A'],
  13: JobRiskClass['3A'],
  14: JobRiskClass['B'],
  15: JobRiskClass['3A'],
  16: JobRiskClass['3A'],
  17: JobRiskClass['3A'],
  18: JobRiskClass['3A'],
  19: JobRiskClass['3A'],
  20: JobRiskClass['3A'],
  21: JobRiskClass['2A'],
  22: JobRiskClass['2A'],
  23: JobRiskClass['2A'],
  24: JobRiskClass['1A'],
  25: JobRiskClass['C'],
  26: JobRiskClass['C'],
  27: JobRiskClass['3A'],
  28: JobRiskClass['3A'],
  29: JobRiskClass['2A'],
  30: JobRiskClass['B'],
  31: JobRiskClass['4A'],
  32: JobRiskClass['1A'],
  33: JobRiskClass['3A'],
  34: JobRiskClass['2A'],
  35: JobRiskClass['1A'],
  36: JobRiskClass['3A'],
  37: JobRiskClass['C'],
  38: JobRiskClass['2A'],
  39: JobRiskClass['1A'],
  40: JobRiskClass['1A'],
  41: JobRiskClass['3A'],
  42: JobRiskClass['2A'],
  43: JobRiskClass['C'],
  44: JobRiskClass['4A'],
  45: JobRiskClass['1A'],
  46: JobRiskClass['C'],
  47: JobRiskClass['3A'],
  48: JobRiskClass['3A'],
  49: JobRiskClass['3A'],
  50: JobRiskClass['1A'],
  51: JobRiskClass['1A'],
  52: JobRiskClass['1A'],
  53: JobRiskClass['1A'],
  54: JobRiskClass['3A'],
  55: JobRiskClass['2A'],
  56: JobRiskClass['4A'],
  57: JobRiskClass['4A'],
  58: JobRiskClass['3A'],
  59: JobRiskClass['1A'],
  60: JobRiskClass['4A'],
  61: JobRiskClass['4A'],
  62: JobRiskClass['4A'],
  63: JobRiskClass['3A'],
  64: JobRiskClass['1A'],
  65: JobRiskClass['1A'],
  66: JobRiskClass['1A'],
  67: JobRiskClass['1A'],
  68: JobRiskClass['1A'],
  69: JobRiskClass['1A'],
  70: JobRiskClass['C'],
  71: JobRiskClass['2A'],
  72: JobRiskClass['2A'],
  73: JobRiskClass['1A'],
  74: JobRiskClass['2A'],
  75: JobRiskClass['C'],
  76: JobRiskClass['C'],
  77: JobRiskClass['C'],
  78: JobRiskClass['4A'],
  79: JobRiskClass['4A'],
  80: JobRiskClass['3A'],
  81: JobRiskClass['3A'],
  82: JobRiskClass['4A'],
  83: JobRiskClass['4A'],
  84: JobRiskClass['2A'],
  85: JobRiskClass['C'],
  86: JobRiskClass['1A'],
  87: JobRiskClass['C'],
  88: JobRiskClass['B'],
  89: JobRiskClass['3A'],
  90: JobRiskClass['4A'],
  91: JobRiskClass['2A'],
  92: JobRiskClass['C'],
  93: JobRiskClass['1A'],
  94: JobRiskClass['4A'],
  95: JobRiskClass['1A'],
  96: JobRiskClass['1A'],
  97: JobRiskClass['2A'],
  98: JobRiskClass['B'],
  99: JobRiskClass['C'],
  100: JobRiskClass['C'],
  101: JobRiskClass['C'],
  102: JobRiskClass['2A'],
  103: JobRiskClass['1A'],
  104: JobRiskClass['C'],
  105: JobRiskClass['2A'],
  106: JobRiskClass['2A'],
  107: JobRiskClass['4A'],
  108: JobRiskClass['3A'],
  109: JobRiskClass['1A'],
  110: JobRiskClass['1A'],
  111: JobRiskClass['C'],
  112: JobRiskClass['2A'],
  113: JobRiskClass['1A'],
  114: JobRiskClass['1A'],
  115: JobRiskClass['1A'],
  116: JobRiskClass['1A'],
  117: JobRiskClass['1A'],
  118: JobRiskClass['C'],
  119: JobRiskClass['B'],
  120: JobRiskClass['3A'],
  121: JobRiskClass['B'],
  122: JobRiskClass['3A'],
  123: JobRiskClass['C'],
  124: JobRiskClass['C'],
  125: JobRiskClass['INELIGIBLE'],
  126: JobRiskClass['INELIGIBLE'],
  127: JobRiskClass['INELIGIBLE'],
  128: JobRiskClass['C'],
  129: JobRiskClass['2A'],
  130: JobRiskClass['3A'],
  131: JobRiskClass['2A'],
  132: JobRiskClass['1A'],
  133: JobRiskClass['1A'],
  134: JobRiskClass['C'],
  135: JobRiskClass['1A'],
  136: JobRiskClass['1A'],
  137: JobRiskClass['1A'],
  138: JobRiskClass['1A'],
  139: JobRiskClass['C'],
  140: JobRiskClass['INELIGIBLE'],
  141: JobRiskClass['C'],
  142: JobRiskClass['2A'],
  143: JobRiskClass['1A'],
  144: JobRiskClass['2A'],
  145: JobRiskClass['4A'],
  146: JobRiskClass['2A'],
  147: JobRiskClass['C'],
  148: JobRiskClass['4A'],
  149: JobRiskClass['4A'],
  150: JobRiskClass['4A'],
  151: JobRiskClass['1A'],
  152: JobRiskClass['C'],
  153: JobRiskClass['C'],
  154: JobRiskClass['3A'],
  155: JobRiskClass['2A'],
  156: JobRiskClass['1A'],
  157: JobRiskClass['C'],
  158: JobRiskClass['4A'],
  159: JobRiskClass['3A'],
  160: JobRiskClass['3A'],
  161: JobRiskClass['1A'],
  162: JobRiskClass['C'],
  163: JobRiskClass['4A'],
  164: JobRiskClass['1A'],
  165: JobRiskClass['B'],
  166: JobRiskClass['4A'],
  167: JobRiskClass['3A'],
  168: JobRiskClass['1A'],
  169: JobRiskClass['1A'],
  170: JobRiskClass['B'],
  171: JobRiskClass['2A'],
  172: JobRiskClass['4A'],
  173: JobRiskClass['1A'],
  174: JobRiskClass['1A'],
  175: JobRiskClass['C'],
  176: JobRiskClass['2A'],
  177: JobRiskClass['C'],
  178: JobRiskClass['1A'],
  179: JobRiskClass['3A'],
  180: JobRiskClass['4A'],
  181: JobRiskClass['4A'],
  182: JobRiskClass['3A'],
  183: JobRiskClass['3A'],
  184: JobRiskClass['3A'],
  185: JobRiskClass['3A'],
  186: JobRiskClass['2A'],
  187: JobRiskClass['2A'],
  188: JobRiskClass['1A'],
  189: JobRiskClass['B'],
  190: JobRiskClass['2A'],
  191: JobRiskClass['1A'],
  192: JobRiskClass['1A'],
  193: JobRiskClass['1A'],
  194: JobRiskClass['3A'],
  195: JobRiskClass['2A'],
  196: JobRiskClass['B'],
  197: JobRiskClass['3A'],
  198: JobRiskClass['INELIGIBLE'],
  199: JobRiskClass['C'],
  200: JobRiskClass['C'],
  201: JobRiskClass['1A'],
  202: JobRiskClass['C'],
  203: JobRiskClass['2A'],
  204: JobRiskClass['B'],
  205: JobRiskClass['1A'],
  206: JobRiskClass['4A'],
  207: JobRiskClass['4A'],
  208: JobRiskClass['2A'],
  209: JobRiskClass['2A'],
  210: JobRiskClass['3A'],
  211: JobRiskClass['1A'],
  212: JobRiskClass['2A'],
  213: JobRiskClass['4A'],
  214: JobRiskClass['2A'],
  215: JobRiskClass['2A'],
  216: JobRiskClass['2A'],
  217: JobRiskClass['1A'],
  218: JobRiskClass['C'],
  219: JobRiskClass['3A'],
  220: JobRiskClass['C'],
  221: JobRiskClass['C'],
  222: JobRiskClass['1A'],
  223: JobRiskClass['C'],
  224: JobRiskClass['1A'],
  225: JobRiskClass['C'],
  226: JobRiskClass['C'],
  227: JobRiskClass['1A'],
  228: JobRiskClass['B'],
  229: JobRiskClass['2A'],
  230: JobRiskClass['4A'],
  231: JobRiskClass['3A'],
  232: JobRiskClass['3A'],
  233: JobRiskClass['3A'],
  234: JobRiskClass['2A'],
  235: JobRiskClass['1A'],
  236: JobRiskClass['B'],
  237: JobRiskClass['2A'],
  238: JobRiskClass['1A'],
  239: JobRiskClass['1A'],
  240: JobRiskClass['2A'],
  241: JobRiskClass['1A'],
  242: JobRiskClass['1A'],
  243: JobRiskClass['C'],
  244: JobRiskClass['B'],
  245: JobRiskClass['1A'],
  246: JobRiskClass['B'],
  247: JobRiskClass['2A'],
  248: JobRiskClass['1A'],
  249: JobRiskClass['2A'],
  250: JobRiskClass['2A'],
  251: JobRiskClass['4A'],
  252: JobRiskClass['3A'],
  253: JobRiskClass['2A'],
  254: JobRiskClass['1A'],
  255: JobRiskClass['2A'],
  256: JobRiskClass['2A'],
  257: JobRiskClass['1A'],
  258: JobRiskClass['1A'],
  259: JobRiskClass['B'],
  260: JobRiskClass['B'],
  261: JobRiskClass['B'],
  262: JobRiskClass['C'],
  263: JobRiskClass['B'],
  264: JobRiskClass['1A'],
  265: JobRiskClass['B'],
  266: JobRiskClass['1A'],
  267: JobRiskClass['1A'],
  268: JobRiskClass['1A'],
  269: JobRiskClass['1A'],
  270: JobRiskClass['1A'],
  271: JobRiskClass['4A'],
  272: JobRiskClass['1A'],
  273: JobRiskClass['B'],
  274: JobRiskClass['4A'],
  275: JobRiskClass['1A'],
  276: JobRiskClass['3A'],
  277: JobRiskClass['2A'],
  278: JobRiskClass['1A'],
  279: JobRiskClass['1A'],
  280: JobRiskClass['4A'],
  281: JobRiskClass['3A'],
  282: JobRiskClass['2A'],
  283: JobRiskClass['1A'],
  284: JobRiskClass['B'],
  285: JobRiskClass['2A'],
  286: JobRiskClass['1A'],
  287: JobRiskClass['1A'],
  288: JobRiskClass['1A'],
  289: JobRiskClass['1A'],
  290: JobRiskClass['B'],
  291: JobRiskClass['3A'],
  292: JobRiskClass['2A'],
  293: JobRiskClass['B'],
  294: JobRiskClass['C'],
  295: JobRiskClass['1A'],
  296: JobRiskClass['B'],
  297: JobRiskClass['B'],
  298: JobRiskClass['4A'],
  299: JobRiskClass['2A'],
  300: JobRiskClass['1A'],
  301: JobRiskClass['1A'],
  302: JobRiskClass['B'],
  303: JobRiskClass['C'],
  304: JobRiskClass['B'],
  305: JobRiskClass['C'],
  306: JobRiskClass['1A'],
  307: JobRiskClass['1A'],
  308: JobRiskClass['B'],
  309: JobRiskClass['B'],
  310: JobRiskClass['B'],
  311: JobRiskClass['1A'],
  312: JobRiskClass['1A'],
  313: JobRiskClass['1A'],
  314: JobRiskClass['1A'],
  315: JobRiskClass['1A'],
  316: JobRiskClass['C'],
  317: JobRiskClass['C'],
  318: JobRiskClass['C'],
  319: JobRiskClass['C'],
  320: JobRiskClass['C'],
  321: JobRiskClass['C'],
  322: JobRiskClass['1A'],
  323: JobRiskClass['C'],
  324: JobRiskClass['3A'],
  325: JobRiskClass['2A'],
  326: JobRiskClass['1A'],
  327: JobRiskClass['4A'],
  328: JobRiskClass['3A'],
  329: JobRiskClass['2A'],
  330: JobRiskClass['2A'],
  331: JobRiskClass['3A'],
  332: JobRiskClass['1A'],
  333: JobRiskClass['C'],
  334: JobRiskClass['3A'],
  335: JobRiskClass['1A'],
  336: JobRiskClass['2A'],
  337: JobRiskClass['C'],
  338: JobRiskClass['C'],
  339: JobRiskClass['C'],
  340: JobRiskClass['C'],
  341: JobRiskClass['C'],
  342: JobRiskClass['C'],
  343: JobRiskClass['C'],
  344: JobRiskClass['2A'],
  345: JobRiskClass['2A'],
  346: JobRiskClass['2A'],
  347: JobRiskClass['1A'],
  348: JobRiskClass['2A'],
  349: JobRiskClass['2A'],
  350: JobRiskClass['1A'],
  351: JobRiskClass['3A'],
  352: JobRiskClass['3A'],
  353: JobRiskClass['3A'],
  354: JobRiskClass['3A'],
  355: JobRiskClass['1A'],
  356: JobRiskClass['4A'],
  357: JobRiskClass['3A'],
  358: JobRiskClass['1A'],
  359: JobRiskClass['3A'],
  360: JobRiskClass['3A'],
  361: JobRiskClass['3A'],
  362: JobRiskClass['3A'],
  363: JobRiskClass['4A'],
  364: JobRiskClass['3A'],
  365: JobRiskClass['3A'],
  366: JobRiskClass['3A'],
  367: JobRiskClass['3A'],
  368: JobRiskClass['3A'],
  369: JobRiskClass['3A'],
  370: JobRiskClass['3A'],
  371: JobRiskClass['3A'],
  372: JobRiskClass['3A'],
  373: JobRiskClass['3A'],
  374: JobRiskClass['3A'],
  375: JobRiskClass['3A'],
  376: JobRiskClass['3A'],
  377: JobRiskClass['3A'],
  378: JobRiskClass['3A'],
  379: JobRiskClass['3A'],
  380: JobRiskClass['3A'],
  381: JobRiskClass['3A'],
  382: JobRiskClass['3A'],
  383: JobRiskClass['3A'],
  384: JobRiskClass['4A'],
  385: JobRiskClass['4A'],
  386: JobRiskClass['4A'],
  387: JobRiskClass['3A'],
  388: JobRiskClass['2A'],
  389: JobRiskClass['2A'],
  390: JobRiskClass['2A'],
  391: JobRiskClass['C'],
  392: JobRiskClass['4A'],
  393: JobRiskClass['4A'],
  394: JobRiskClass['B'],
  395: JobRiskClass['3A'],
  396: JobRiskClass['3A'],
  397: JobRiskClass['3A'],
  398: JobRiskClass['1A'],
  399: JobRiskClass['1A'],
  400: JobRiskClass['1A'],
  401: JobRiskClass['1A'],
  402: JobRiskClass['B'],
  403: JobRiskClass['C'],
  404: JobRiskClass['2A'],
  405: JobRiskClass['2A'],
  406: JobRiskClass['1A'],
  407: JobRiskClass['C'],
  408: JobRiskClass['B'],
  409: JobRiskClass['2A'],
  410: JobRiskClass['2A'],
  411: JobRiskClass['2A'],
  412: JobRiskClass['2A'],
  413: JobRiskClass['2A'],
  414: JobRiskClass['1A'],
  415: JobRiskClass['1A'],
  416: JobRiskClass['1A'],
  417: JobRiskClass['C'],
  418: JobRiskClass['C'],
  419: JobRiskClass['C'],
  420: JobRiskClass['C'],
  421: JobRiskClass['C'],
  422: JobRiskClass['C'],
  423: JobRiskClass['C'],
  424: JobRiskClass['C'],
  425: JobRiskClass['4A'],
  426: JobRiskClass['3A'],
  427: JobRiskClass['3A'],
  428: JobRiskClass['2A'],
  429: JobRiskClass['1A'],
  430: JobRiskClass['1A'],
  431: JobRiskClass['B'],
  432: JobRiskClass['B'],
  433: JobRiskClass['1A'],
  434: JobRiskClass['3A'],
  435: JobRiskClass['2A'],
  436: JobRiskClass['1A'],
  437: JobRiskClass['C'],
  438: JobRiskClass['4A'],
  439: JobRiskClass['1A'],
  440: JobRiskClass['4A'],
  441: JobRiskClass['2A'],
  442: JobRiskClass['B'],
  443: JobRiskClass['1A'],
  444: JobRiskClass['C'],
  445: JobRiskClass['1A'],
  446: JobRiskClass['1A'],
  447: JobRiskClass['1A'],
  448: JobRiskClass['B'],
  449: JobRiskClass['2A'],
  450: JobRiskClass['C'],
  451: JobRiskClass['C'],
  452: JobRiskClass['1A'],
  453: JobRiskClass['1A'],
  454: JobRiskClass['1A'],
  455: JobRiskClass['B'],
  456: JobRiskClass['2A'],
  457: JobRiskClass['1A'],
  458: JobRiskClass['4A'],
  459: JobRiskClass['3A'],
  460: JobRiskClass['1A'],
  461: JobRiskClass['1A'],
  462: JobRiskClass['3A'],
  463: JobRiskClass['3A'],
  464: JobRiskClass['3A'],
  465: JobRiskClass['2A'],
  466: JobRiskClass['C'],
  467: JobRiskClass['3A'],
  468: JobRiskClass['3A'],
  469: JobRiskClass['3A'],
  470: JobRiskClass['1A'],
  471: JobRiskClass['C'],
  472: JobRiskClass['1A'],
  473: JobRiskClass['2A'],
  474: JobRiskClass['3A'],
  475: JobRiskClass['1A'],
  476: JobRiskClass['B'],
  477: JobRiskClass['B'],
  478: JobRiskClass['C'],
  479: JobRiskClass['1A'],
  480: JobRiskClass['3A'],
  481: JobRiskClass['2A'],
  482: JobRiskClass['1A'],
  483: JobRiskClass['1A'],
  484: JobRiskClass['1A'],
  485: JobRiskClass['C'],
  486: JobRiskClass['2A'],
  487: JobRiskClass['1A'],
  488: JobRiskClass['1A'],
  489: JobRiskClass['B'],
  490: JobRiskClass['B'],
  491: JobRiskClass['C'],
  492: JobRiskClass['C'],
  493: JobRiskClass['4A'],
  494: JobRiskClass['4A'],
  495: JobRiskClass['2A'],
  496: JobRiskClass['2A'],
  497: JobRiskClass['2A'],
  498: JobRiskClass['1A'],
  499: JobRiskClass['1A'],
  500: JobRiskClass['B'],
  501: JobRiskClass['B'],
  502: JobRiskClass['3A'],
  503: JobRiskClass['2A'],
  504: JobRiskClass['1A'],
  505: JobRiskClass['1A'],
  506: JobRiskClass['1A'],
  507: JobRiskClass['1A'],
  508: JobRiskClass['1A'],
  509: JobRiskClass['1A'],
  510: JobRiskClass['1A'],
  511: JobRiskClass['1A'],
  512: JobRiskClass['1A'],
  513: JobRiskClass['1A'],
  514: JobRiskClass['1A'],
  515: JobRiskClass['1A'],
  516: JobRiskClass['1A'],
  517: JobRiskClass['1A'],
  518: JobRiskClass['1A'],
  519: JobRiskClass['B'],
  520: JobRiskClass['B'],
  521: JobRiskClass['B'],
  522: JobRiskClass['B'],
  523: JobRiskClass['B'],
  524: JobRiskClass['B'],
  525: JobRiskClass['4A'],
  526: JobRiskClass['2A'],
  527: JobRiskClass['2A'],
  528: JobRiskClass['4A'],
  529: JobRiskClass['2A'],
  530: JobRiskClass['2A'],
  531: JobRiskClass['2A'],
  532: JobRiskClass['1A'],
  533: JobRiskClass['4A'],
  534: JobRiskClass['4A'],
  535: JobRiskClass['4A'],
  536: JobRiskClass['2A'],
  537: JobRiskClass['4A'],
  538: JobRiskClass['1A'],
  539: JobRiskClass['1A'],
  540: JobRiskClass['1A'],
  541: JobRiskClass['1A'],
  542: JobRiskClass['B'],
  543: JobRiskClass['B'],
  544: JobRiskClass['C'],
  545: JobRiskClass['C'],
  546: JobRiskClass['C'],
  547: JobRiskClass['C'],
  548: JobRiskClass['B'],
  549: JobRiskClass['1A'],
  550: JobRiskClass['B'],
  551: JobRiskClass['3A'],
  552: JobRiskClass['1A'],
  553: JobRiskClass['2A'],
  554: JobRiskClass['1A'],
  555: JobRiskClass['B'],
  556: JobRiskClass['B'],
  557: JobRiskClass['C'],
  558: JobRiskClass['B'],
  559: JobRiskClass['C'],
  560: JobRiskClass['C'],
  561: JobRiskClass['C'],
  562: JobRiskClass['C'],
  563: JobRiskClass['1A'],
  564: JobRiskClass['C'],
  565: JobRiskClass['C'],
  566: JobRiskClass['C'],
  567: JobRiskClass['C'],
  568: JobRiskClass['4A'],
  569: JobRiskClass['3A'],
  570: JobRiskClass['2A'],
  571: JobRiskClass['2A'],
  572: JobRiskClass['3A'],
  573: JobRiskClass['C'],
  574: JobRiskClass['1A'],
  575: JobRiskClass['2A'],
  576: JobRiskClass['B'],
  577: JobRiskClass['2A'],
  578: JobRiskClass['1A'],
  579: JobRiskClass['B'],
  580: JobRiskClass['B'],
  581: JobRiskClass['B'],
  582: JobRiskClass['C'],
  583: JobRiskClass['C'],
  584: JobRiskClass['4A'],
  585: JobRiskClass['4A'],
  586: JobRiskClass['1A'],
  587: JobRiskClass['2A'],
  588: JobRiskClass['2A'],
  589: JobRiskClass['2A'],
  590: JobRiskClass['B'],
  591: JobRiskClass['B'],
  592: JobRiskClass['B'],
  593: JobRiskClass['C'],
  594: JobRiskClass['1A'],
  595: JobRiskClass['2A'],
  596: JobRiskClass['B'],
  597: JobRiskClass['2A'],
  598: JobRiskClass['2A'],
  599: JobRiskClass['2A'],
  600: JobRiskClass['B'],
  601: JobRiskClass['C'],
  602: JobRiskClass['1A'],
  603: JobRiskClass['B'],
  604: JobRiskClass['1A'],
  605: JobRiskClass['1A'],
  606: JobRiskClass['B'],
  607: JobRiskClass['1A'],
  608: JobRiskClass['1A'],
  609: JobRiskClass['INELIGIBLE'],
  610: JobRiskClass['3A'],
  611: JobRiskClass['3A'],
  612: JobRiskClass['3A'],
  613: JobRiskClass['3A'],
  614: JobRiskClass['1A'],
  615: JobRiskClass['1A'],
  616: JobRiskClass['1A'],
  617: JobRiskClass['C'],
  618: JobRiskClass['2A'],
  619: JobRiskClass['3A'],
  620: JobRiskClass['2A'],
  621: JobRiskClass['3A'],
  622: JobRiskClass['3A'],
  623: JobRiskClass['3A'],
  624: JobRiskClass['3A'],
  625: JobRiskClass['3A'],
  626: JobRiskClass['3A'],
  627: JobRiskClass['3A'],
  628: JobRiskClass['3A'],
  629: JobRiskClass['3A'],
  630: JobRiskClass['3A'],
  631: JobRiskClass['3A'],
  632: JobRiskClass['2A'],
  633: JobRiskClass['2A'],
  634: JobRiskClass['2A'],
  635: JobRiskClass['2A'],
  636: JobRiskClass['2A'],
  637: JobRiskClass['2A'],
  638: JobRiskClass['2A'],
  639: JobRiskClass['2A'],
  640: JobRiskClass['2A'],
  641: JobRiskClass['1A'],
  642: JobRiskClass['B'],
  643: JobRiskClass['C'],
  644: JobRiskClass['C'],
  645: JobRiskClass['3A'],
  646: JobRiskClass['4A'],
  647: JobRiskClass['4A'],
  648: JobRiskClass['4A'],
  649: JobRiskClass['2A'],
  650: JobRiskClass['4A'],
  651: JobRiskClass['B'],
  652: JobRiskClass['C'],
  653: JobRiskClass['3A'],
  654: JobRiskClass['1A'],
  655: JobRiskClass['2A'],
  656: JobRiskClass['3A'],
  657: JobRiskClass['3A'],
  658: JobRiskClass['2A'],
  659: JobRiskClass['2A'],
  660: JobRiskClass['3A'],
  661: JobRiskClass['1A'],
  662: JobRiskClass['1A'],
  663: JobRiskClass['2A'],
  664: JobRiskClass['2A'],
  665: JobRiskClass['1A'],
  666: JobRiskClass['1A'],
  667: JobRiskClass['1A'],
  668: JobRiskClass['B'],
  669: JobRiskClass['C'],
  670: JobRiskClass['3A'],
  671: JobRiskClass['3A'],
  672: JobRiskClass['2A'],
  673: JobRiskClass['INELIGIBLE'],
  674: JobRiskClass['INELIGIBLE'],
  675: JobRiskClass['INELIGIBLE'],
  676: JobRiskClass['2A'],
  677: JobRiskClass['1A'],
  678: JobRiskClass['3A'],
  679: JobRiskClass['2A'],
  680: JobRiskClass['1A'],
  681: JobRiskClass['1A'],
  682: JobRiskClass['2A'],
  683: JobRiskClass['2A'],
  684: JobRiskClass['C'],
  685: JobRiskClass['3A'],
  686: JobRiskClass['2A'],
  687: JobRiskClass['1A'],
  688: JobRiskClass['C'],
  689: JobRiskClass['B'],
  690: JobRiskClass['4A'],
  691: JobRiskClass['C'],
  692: JobRiskClass['C'],
  693: JobRiskClass['2A'],
  694: JobRiskClass['2A'],
  695: JobRiskClass['B'],
  696: JobRiskClass['1A'],
  697: JobRiskClass['3A'],
  698: JobRiskClass['3A'],
  699: JobRiskClass['3A'],
  700: JobRiskClass['1A'],
  701: JobRiskClass['B'],
  702: JobRiskClass['C'],
  703: JobRiskClass['2A'],
  704: JobRiskClass['1A'],
  705: JobRiskClass['1A'],
  706: JobRiskClass['1A'],
  707: JobRiskClass['1A'],
  708: JobRiskClass['3A'],
  709: JobRiskClass['2A'],
  710: JobRiskClass['2A'],
  711: JobRiskClass['1A'],
  712: JobRiskClass['1A'],
  713: JobRiskClass['1A'],
  714: JobRiskClass['B'],
  715: JobRiskClass['C'],
  716: JobRiskClass['2A'],
  717: JobRiskClass['3A'],
  718: JobRiskClass['3A'],
  719: JobRiskClass['3A'],
  720: JobRiskClass['3A'],
  721: JobRiskClass['2A'],
  722: JobRiskClass['2A'],
  723: JobRiskClass['2A'],
  724: JobRiskClass['2A'],
  725: JobRiskClass['2A'],
  726: JobRiskClass['2A'],
  727: JobRiskClass['2A'],
  728: JobRiskClass['2A'],
  729: JobRiskClass['1A'],
  730: JobRiskClass['1A'],
  731: JobRiskClass['1A'],
  732: JobRiskClass['C'],
  733: JobRiskClass['C'],
  734: JobRiskClass['1A'],
  735: JobRiskClass['3A'],
  736: JobRiskClass['1A'],
  737: JobRiskClass['B'],
  738: JobRiskClass['1A'],
  739: JobRiskClass['2A'],
  740: JobRiskClass['B'],
  741: JobRiskClass['4A'],
  742: JobRiskClass['3A'],
  743: JobRiskClass['3A'],
  744: JobRiskClass['1A'],
  745: JobRiskClass['C'],
  746: JobRiskClass['3A'],
  747: JobRiskClass['2A'],
  748: JobRiskClass['1A'],
  749: JobRiskClass['1A'],
  750: JobRiskClass['4A'],
  751: JobRiskClass['1A'],
  752: JobRiskClass['1A'],
  753: JobRiskClass['1A'],
  754: JobRiskClass['1A'],
  755: JobRiskClass['1A'],
  756: JobRiskClass['3A'],
  757: JobRiskClass['2A'],
  758: JobRiskClass['4A'],
  759: JobRiskClass['B'],
  760: JobRiskClass['3A'],
  761: JobRiskClass['2A'],
  762: JobRiskClass['1A'],
  763: JobRiskClass['3A'],
  764: JobRiskClass['B'],
  765: JobRiskClass['3A'],
  766: JobRiskClass['3A'],
  767: JobRiskClass['3A'],
  768: JobRiskClass['2A'],
  769: JobRiskClass['2A'],
  770: JobRiskClass['B'],
  771: JobRiskClass['2A'],
  772: JobRiskClass['1A'],
  774: JobRiskClass['B'],
  775: JobRiskClass['4A'],
  776: JobRiskClass['4A'],
  777: JobRiskClass['4A'],
  778: JobRiskClass['1A'],
  779: JobRiskClass['C'],
  782: JobRiskClass['C'],
  783: JobRiskClass['2A'],
  785: JobRiskClass['3A'],
  788: JobRiskClass['C'],
  789: JobRiskClass['3A'],
  790: JobRiskClass['3A'],
  791: JobRiskClass['C'],
  792: JobRiskClass['C'],
  793: JobRiskClass['C'],
  794: JobRiskClass['C'],
  795: JobRiskClass['C'],
  796: JobRiskClass['C'],
  797: JobRiskClass['4A'],
  798: JobRiskClass['4A'],
  800: JobRiskClass['2A'],
  801: JobRiskClass['1A'],
  802: JobRiskClass['3A'],
  803: JobRiskClass['2A'],
  804: JobRiskClass['2A'],
  805: JobRiskClass['2A'],
  806: JobRiskClass['2A'],
  809: JobRiskClass['2A'],
  810: JobRiskClass['1A'],
  811: JobRiskClass['3A'],
  812: JobRiskClass['C'],
  813: JobRiskClass['1A'],
  814: JobRiskClass['INELIGIBLE'],
  815: JobRiskClass['3A'],
  816: JobRiskClass['4A'],
  817: JobRiskClass['1A'],
  818: JobRiskClass['INELIGIBLE'],
  819: JobRiskClass['INELIGIBLE'],
};
